import {Component, ElementRef, OnInit, ViewChild, ViewContainerRef, Directive, HostListener, Input} from '@angular/core';
import {AbstractControl, NgForm, FormGroup, FormBuilder, Validators, NgModel, FormsModule} from '@angular/forms';
import {TrialService} from './trial.service';
import {TrialRegistration} from './trial';
import {LoadingModal} from '../modals/modal-loading.component';
import {Subscription} from 'rxjs/Subscription';
import {LoginService} from '../login/user-login.service';
import {tos, tosName, tosPath} from '../licensing/tos';
import {ModalLicensingArgs} from '../licensing/modal-licensing-args';
import {User} from '../user/user';
import {UserLogin} from '../login/user-login';
import {UserService} from '../user/user.service';
import {ActivatedRoute, Router} from '@angular/router';
import {LicensingModal} from '../licensing/licensing-modal.component';
import {TOSEntry} from '../headerfooter/setting-entries/tos-entry';
import {AwsEnvironment} from '../aws/environment';


declare var grecaptcha: any;

export function ValidatePwordRetry(c: AbstractControl) {
    // self value
    let v = c.value;
    let validateEqual = "pword";
    // control vlaue
    let e = c.root.get(validateEqual);

    // value not equal
    if (e && v !== e.value ) {
        return {
            validateEqual: false
        }
    }

    return null;
}

export function ValidateWhitespace(c: AbstractControl) {
    let isWhitespace = (c.value || '').trim().length === 0;
    let isValid = !isWhitespace;
    return isValid ? null : { 'whitespace': 'value is only whitespace' }
}

@Directive({
    selector: '[validateOnBlur]',
})

export class ValidateOnBlur {
    static addFirstNameValidator(model: NgModel, triggerValidation:boolean = false, required:boolean = true) {
        model.control.clearValidators();
        model.control.clearAsyncValidators();

        var validators = [
            Validators.pattern(/^[a-zA-Z\-\s]*$/),
            Validators.maxLength(32),
            ValidateWhitespace
        ]

        if (required)
            validators.push(Validators.required)

        model.control.setValidators(validators);

        if (triggerValidation) {
            model.control.updateValueAndValidity();
        }
    }

    static addLastNameValidator(model: NgModel, triggerValidation:boolean = false, required:boolean = true) {
        model.control.clearValidators();
        model.control.clearAsyncValidators();

        var validators = [
            Validators.pattern(/^[a-zA-Z\-\s]*$/),
            Validators.maxLength(32),
            ValidateWhitespace
        ]

        if (required)
            validators.push(Validators.required)

        model.control.setValidators(validators);

        if (triggerValidation) {
            model.control.updateValueAndValidity();
        }
    }

    static addEmailValidator(model: NgModel, triggerValidation:boolean = false) {
            model.control.setValidators([
                Validators.maxLength(64),
                ValidateWhitespace,
                Validators.pattern(/^[-a-z0-9~!$%^&*_=+}{\'?]+(\.[-a-z0-9~!$%^&*_=+}{\'?]+)*@([a-z0-9_][-a-z0-9_]*(\.[-a-z0-9_]+)*\.([a-z]{2,63})|([0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}))(:[0-9]{1,5})?$/i),
                Validators.required]);
        if (triggerValidation) {
            model.control.updateValueAndValidity();
        }
    }

    static addPasswordValidator(model: NgModel, triggerValidation:boolean = false, matchPass = true) {
        model.control.setValidators([
            Validators.required,
            ValidateWhitespace,
            Validators.pattern(`^(?=.*\\d)(?=.*[A-Z])[\\S][^\\>\\<]{7,}$`),
            Validators.minLength(8),
            Validators.maxLength(32)

        ]);

        if (matchPass) {
            let pwdRetry = model.control.root.get("pwordRetry");
            pwdRetry.setValidators([
                Validators.required
            ])

            pwdRetry.updateValueAndValidity();
        }

        if (triggerValidation) {
            model.control.updateValueAndValidity();
        }
    }

    static addPasswordRetryValidator(model: NgModel, triggerValidation:boolean = false, matchPass = true) {
        if (matchPass) {
            model.control.setValidators([
                Validators.required,
                ValidateWhitespace,
                ValidatePwordRetry
            ]);
        }
        else
            model.control.setValidators([]);

        if (triggerValidation) {
            model.control.updateValueAndValidity();
        }
    }

    static removePasswordRetryValidator(model: NgModel) {
        model.control.setValidators([]);
    }

    @Input('blurModel') model: NgModel;
    constructor(

    ) {
    }
    @HostListener('focus', ['$event.target'])
    onFocus(target: any) {
        this.model.control.markAsUntouched();
        this.model.control.markAsPristine();
        this.model.control.clearValidators();
        this.model.control.clearAsyncValidators();
    }

    @HostListener('focusout', ['$event.target'])
    onFocusout(target: any) {
        switch (this.model.name) {
            case "email": {
                ValidateOnBlur.addEmailValidator(this.model);
                break;
            }
            case "fname": {
                ValidateOnBlur.addFirstNameValidator(this.model);
                break;
            }
            case "lname": {
                ValidateOnBlur.addLastNameValidator(this.model);
                break;
            }
            case "pword": {
                ValidateOnBlur.addPasswordValidator(this.model);
                break;
            }
            case "pwordRetry": {
                ValidateOnBlur.addPasswordRetryValidator(this.model);
                break;
            }
        }
        if (this.model.control.value) {
            (this.model.control as any).hadValue = true;
            this.model.control.markAsTouched();
            this.model.control.markAsDirty();
        }
        if ((this.model.control as any).hadValue) {
            this.model.control.markAsDirty();
        }

        this.model.control.updateValueAndValidity();
    }
}

@Component({
    selector: 'trial',
    templateUrl: './trial.component.html',
    styleUrls: [
        './trial.component.scss',
        '../../../node_modules/bootstrap/dist/css/bootstrap.css'
    ]
})


export class TrialComponent implements OnInit {

    public captchaResponse: boolean = false;
    public registered: boolean = false;
    public error: String = '';
    public node: any;
    public forgotPasswordUrl = '';
    public trialStatusSubscription: Subscription;
    public passPlaceholder = "Choose a password";

    public showRegCode: boolean = false;
    public showPromoCode: boolean = false;
    public showAlreadyUserLogin: boolean = false;
    public createAccountCredSubscription: Subscription;

    @ViewChild('loading') private loading: LoadingModal;
    @ViewChild('license') private license: LicensingModal;
    @ViewChild('trialForm') trialForm: NgForm;

    public trialParams: TrialRegistration;


    constructor(private trialService: TrialService,
                private loginService: LoginService,
                private userService:UserService,
                private router: Router,
                private route: ActivatedRoute,
                private tosEntry: TOSEntry,
                private viewContainerRef: ViewContainerRef,
                private awsEnv: AwsEnvironment){

        window['verifyCallback'] = this.verifyCallback.bind(this);
        window['onloadCallback'] = this.onloadCallback.bind(this);

        this.trialParams = {
            Email: '',
            FirstName: '',
            LastName: '',
            Captcha: '',
            Password: '',
            Trial: true,
            UserExists: false,
            RegCode: '',
            PromoCode: ''
        };

        this.loadRecaptchaScript();

    }


    ngOnInit() {
        this.showRegCode = this.awsEnv.getShowRegCode();
        this.showPromoCode = this.awsEnv.getShowPromoCode();

        this.trialStatusSubscription = this.trialService.trialStatusChanged
            .subscribe(
                (response) =>{
                    if(response.trialMode && response.max === 0){
                        this.registered = true;
                    }
                }
            );

        this.forgotPasswordUrl = this.awsEnv.getForgotPasswordUrl();
        this.createAccountCredSubscription = this.trialService.createAccountCredentials
            .subscribe(
                (credentials) => {
                    if(credentials === 'CREATED') {
                        //console.log('credentials->' + credentials);
                        setTimeout(() => {
                            this.loginUser();
                        }, 10000);

                    } else {
                        this.error = 'An error has occurred. Please try again.';
                        this.hideLoadingProgress();
                        this.trialForm.reset();
                        grecaptcha.reset();
                    }
                },
                (error: string) => {
                    this.error = error;
                    this.hideLoadingProgress();
                    grecaptcha.reset();
                }

            );

    }

    loadRecaptchaScript(){
        if(!this.node){
            this.node = document.createElement('script');
            this.node.src = "https://www.google.com/recaptcha/api.js?onload=onloadCallback&render=explicit";
            this.node.type = 'text/javascript';
            this.node.async = true;
            this.node.defer = true;
            this.node.charset = 'utf-8';
            document.getElementsByTagName('head')[0].appendChild(this.node);
        }
    }

    submitTrial() {
        this.trialParams.UserExists = this.showAlreadyUserLogin;
        //console.log(this.trialParams);
        this.showLoadingProgress('creating user');
        this.trialService.postTrialRegistration(this.trialParams).subscribe(
            (registration) => {
                //console.log(registration);
                this.trialService.pollTrialRegistration(registration.RequestId);
            },
            (error: string) => {
                this.error = error;
                this.hideLoadingProgress();
                grecaptcha.reset();
            }
        )
    }

    loginUser() {
        this.loginService.login(new UserLogin(this.trialParams.Email, this.trialParams.Password))
            .subscribe(
                (user: User) => {
                    this.loginService.userLoggedIn(true);
                    this.userService.setCurrentUser(user, true)
                        .then(() => {
                            this.registered = true;
                            this.hideLoadingProgress();
                            //this.startTrial();
                        })
                        .catch(error => {
                            this.error = error;
                            this.hideLoadingProgress();
                            grecaptcha.reset();
                        });
                },
                (error: string) => {
                    this.error = error;
                    this.hideLoadingProgress();
                    grecaptcha.reset();
                },
            );
    }

    startTrial() {
        let email = this.trialParams.Email;
        let promoCode = this.trialParams.PromoCode;

        if(!email){
           email = this.userService.getCurrentUser().Email;
        }


        this.showLoadingProgress('activating your trial account');
        this.trialService.accountActivation(email, promoCode)
            .subscribe(
                result => {
                    this.trialService.accountStatus(email).subscribe(
                        result => {
                            this.hideLoadingProgress();
                            this.trialService.trialStatusChanged.next({trialMode: result.trial,
                                trialModeExpired: result.expired,
                                trialData: this.trialService.bytesToSize(result.remaining)});
                            this.routeToDashboard();
                        },
                        (error: string) => {
                            this.error = error;
                            this.hideLoadingProgress();
                        }
                    )
                },
                (error: string) => {
                    this.error = error;
                    this.hideLoadingProgress();
                    grecaptcha.reset();
                },
            );
    }

    routeToDashboard() {
        this.router.navigate(['dashboard'], {relativeTo: this.route});
    }

    verifyCallback(response: any){
        this.trialParams.Captcha = response;
        this.captchaResponse = true;
    }

    onloadCallback(){
        grecaptcha.render('create-account-captcha', {
            'sitekey': '6LeRCkgUAAAAAOs6KfbxeoCu1F4Q09D4HIvtHnPG',
            'callback': 'verifyCallback'
        });
    }


    showLoadingProgress(value: string) {
        if(!this.loading.isOn){
            this.loading.showDialog(value);
            this.loading.setShowStopTest(true);
            this.loading.setShowOkButton(false);
        } else {
            this.loading.updateDialog(value);
            this.loading.setShowStopTest(true);
            this.loading.setShowOkButton(false);
        }

    }

    hideLoadingProgress() {
        this.loading.closeDialog();
    }

    onAlreadyUserChange(event:any) {
        if (event.target.checked) {
            this.showAlreadyUserLogin = true;
        } else {
            this.showAlreadyUserLogin = false;
        }
    }

    showTOS() {
        this.tosEntry.activate(this.viewContainerRef);
    }

    getShowAlreadyUser() {
        if(this.showAlreadyUserLogin) {
            return 'none';
        } else {
            return 'flex';
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/trial/trial.component.ts